import axios from "axios";

const BASE_API_URL = "/api/payment";

class PaymentService {
  // 建立點數訂單，取得 ECPay 付款參數
  //   invoice: 由 /checkout 產出的發票資訊（type/carrier/donation/b2b/email/…），付款成功 callback 拿來開票
  createOrder(planID, invoice = null) {
    return axios.post(BASE_API_URL + "/create", { planID, invoice });
  }

  // 建立數位服務訂單，取得 ECPay 付款參數（payload 依 planID 不同而異，會存進訂單供付款 callback 使用）
  //   invoice: 同上
  //   couponCode: 兌換碼字串（optional）；帶入時後端會 atomic 扣次+折抵
  createDigitalOrder(planID, payload = {}, invoice = null, couponCode = "") {
    return axios.post(BASE_API_URL + "/create-digital", {
      planID,
      payload,
      invoice,
      couponCode,
    });
  }

  // 驗證兌換碼（前端「套用」button 用；不會扣次，只是查是否可用 + 折抵金額）
  //  planID：帶入才能驗證「此商品是否適用」；一人一次限制走 JWT userID
  //  回傳 data: { valid, code?, discountAmount?, resultCode? }
  validateCoupon(code, planID = "") {
    return axios.post(BASE_API_URL + "/validate-coupon", { code, planID });
  }

  // 查單一訂單付款狀態（給 Meta Pixel Purchase 事件判定用）
  //  回：{ paid, planID, amount }；查無或不是自己的訂單一律回 paid=false
  checkOrderPaid(orderID) {
    return axios.post(BASE_API_URL + "/order-paid-check", { orderID });
  }

  // IAP 驗證（App 端專用）— A-Point 儲值走 Google Play / Apple IAP
  //  App 拿到商店回應後 → 呼叫此 API → 後端向商店驗證 + 加點
  //  Android body：{ platform: "android", planID, purchaseToken }
  //  iOS     body：{ platform: "ios", planID, transactionId }
  //  回傳 data.resultCode:
  //    ok / already_credited / plan_not_found / verify_failed / server_error
  //  Deprecated：新代碼請走 verifyIosIap / verifyAndroidIap（拆平台版本）
  verifyIap({ platform, planID, purchaseToken, transactionId }) {
    return axios.post("/api/purchase/iap/verify", {
      platform,
      planID,
      purchaseToken,
      transactionId,
    });
  }

  // iOS IAP 驗證（App iOS 專用）— A-Point 儲值
  //  body: { productID, transactionId }
  //    productID：Apple StoreKit Transaction.productID（例 "yuanchen_point_300"）
  //    transactionId：Apple StoreKit Transaction.id
  //  回傳 data.resultCode: ok / already_credited / plan_not_found / verify_failed
  verifyIosIap({ productID, transactionId }) {
    return axios.post("/api/purchase/iap/apple/verify", {
      productID,
      transactionId,
    });
  }
}

export default new PaymentService();
